export default "__VITE_ASSET__QQfavI2W__"